import { round } from 'lodash';

export interface TotalSleepHourAndMinute {
  hours: number;
  minutes: number;
}

export type ConvertedMealMacro = Record<
  string,
  {
    value: number;
    unit: string;
  }
>;

/**
 * Translates the given number of seconds into hours and minutes.
 * @param targetSeconds The number of seconds to be translated.
 * @returns An object containing the translated hours and minutes.
 */
export const translateSecondsToHourAndMinutes = (
  targetSeconds: number
): TotalSleepHourAndMinute => {
  const hours = Math.floor(targetSeconds / (60 * 60));
  const minutes = Math.round(targetSeconds / 60 - hours * 60);
  return { hours, minutes };
};

export const convertMealMacro = (macros: { [key: string]: number }) => {
  return Object.entries(macros).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined && value > 0) {
      // Extract unit from key (e.g., "fat_g" -> "g", "sodium_mg" -> "mg")
      let unit = '';
      let cleanKey = key;

      if (key === 'calories') {
        unit = 'cal';
        cleanKey = 'calories';
      } else {
        const unitMatch = key.match(/_([a-z]+)$/);
        unit = unitMatch ? unitMatch[1] : '';
        cleanKey = key.replace(/_([a-z]+)$/, '');
      }

      acc[cleanKey] = { value: round(value, 2), unit };
    }
    return acc;
  }, {} as ConvertedMealMacro);
};
